'use strict';



const $ = require('jquery');
const toggleClassName = 'js-compact-account-toggle';
const contentClassName = 'js-compact-account-content';
const $content = $(`.${contentClassName}`);
const state = { open: false };



$('body').on('click', `.${toggleClassName}`, toggle);



function toggle() {

	if(state.open) {
		close();
		return;
	}

	open();

}



function open() {
	state.open = true;
	$content.show();
}



function close() {
	state.open = false;
	$content.hide();
}